import PageCommon from "./PageCommon.js";
import Pqp from "../3x1010/Pqp.js";
import Globals from "../Globals.js";


export default class PageDefault extends PageCommon {
	constructor() {
		super();
	}
	init( $data ) {
		super.init($data );
		this.showPreloader(false);
		Pqp.trace("PageDefault - Hello world"); 

		// dispaccio un evento globale
		try {
			this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);
		} catch (error) {
			console.log(error);
        }
	}

	get isHomepage() {
		return true;
	}

}

